import React from 'react';

export const EmptyGame = ({ className = '' }) => <div className={className} />;
